import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export type CircularIndicatorState = 'unvisited' | 'current step' | 'complete';

export const Container = styled.div<{
  state: CircularIndicatorState;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 39px;
  height: 39px;
  border-radius: 20px;
  ${(props) => {
    switch (props.state) {
      case 'unvisited':
        return `
          background-color: ${props.theme.atlas.semantic.color.status.neutral.background};
        `;
      case 'current step':
        return `
          background-color: ${props.theme.atlas.semantic.color.action.primary.default};
        `;
      case 'complete':
        return `
          background-color: ${props.theme.atlas.semantic.color.status.success.background};
        `;
    }
  }};
`;

export const StepText = styled.p<{
  state: CircularIndicatorState;
}>`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${({ state, theme }) => {
    switch (state) {
      case 'current step':
      case 'complete':
        return theme.atlas.semantic.color.action.primary.onPrimary;
      case 'unvisited':
      default:
        return theme.atlas.semantic.color.type.default;
    }
  }};
`;

export const CheckIcon = styled(StyledIcon)`
  color: ${(props) => props.theme.atlas.semantic.color.status.success.text};
`;
